import { NodeViewWrapper } from "@tiptap/react";
import { X } from "lucide-react";

const STATUSER = [["open", "Åpen"], ["direction", "Retning"], ["decided", "Besluttet"]];
const HODE = { open: "Beslutning kreves", direction: "Retning valgt", decided: "✓ Besluttet" };

export default function BeslutningBlokk({ node, updateAttributes, deleteNode }) {
  const { status, tittel, alt, notat, anbefalt, eier, frist } = node.attrs;
  const valg = (alt || "").split("·").map((s) => s.trim()).filter(Boolean);
  const fristTekst = frist ? new Date(frist).toLocaleDateString("nb-NO", { day: "numeric", month: "short" }) : "";

  return (
    <NodeViewWrapper className={`dok-blokk dok-besl2 s-${status}`} data-testid="dok-blokk-beslutning">
      <div className="dok-blokk-hode" contentEditable={false}>
        <span className={`dok-besl2-hode s-${status}`}>{HODE[status] || HODE.open}</span>
        {(eier || fristTekst) && (
          <span className="dok-besl2-ansvar" data-testid="dok-besl-ansvar">
            {eier && <><i>{eier[0]}</i>{eier}</>}
            {eier && fristTekst && <span className="skille">·</span>}
            {fristTekst && (status === "decided" ? `Besluttet ${fristTekst}` : `Due ${fristTekst}`)}
          </span>
        )}
        <span className="flex-1" />
        <div className="dok-blokk-seg dok-besl2-seg">
          {STATUSER.map(([k, l]) => (
            <button key={k} type="button" onClick={() => updateAttributes({ status: k })}
              className={status === k ? "aktiv" : ""} data-testid={`dok-besl-status-${k}`}>{l}</button>
          ))}
        </div>
        <button type="button" className="dok-blokk-knapp slett" onClick={deleteNode} title="Fjern" data-testid="dok-besl-slett"><X size={12} /></button>
      </div>

      <div className="dok-besl2-vis" contentEditable={false}>
        <p className="dok-besl2-tittelvis">{tittel || "Uten tittel"}</p>
        {status === "decided" && notat ? (
          <p className="dok-besl2-vedtak" data-testid="dok-besl-vedtak">{notat}</p>
        ) : (
          <div className="dok-besl2-kort">
            {notat && (
              <div className="felt">
                <p className="k">Question</p>
                <p className="v">{notat}</p>
              </div>
            )}
            {anbefalt && (
              <div className="felt">
                <p className="k">Recommended</p>
                <p className="v anbefalt">{anbefalt}</p>
              </div>
            )}
            {valg.length > 0 && (
              <div className="felt">
                <p className="k">Options</p>
                <div className="dok-besl2-valg">
                  {valg.map((v) => <span key={v} className="dok-besl2-alt-chip">{v}</span>)}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="dok-besl2-edit" contentEditable={false}>
        <input value={tittel} onChange={(e) => updateAttributes({ tittel: e.target.value })}
          placeholder="Hva skal besluttes?" className="dok-besl-tittel" data-testid="dok-besl-tittel" />
        <input value={alt} onChange={(e) => updateAttributes({ alt: e.target.value })}
          placeholder="Alternativer — skill med · (f.eks. Eksklusiv · Parallell)" className="dok-besl-alt" data-testid="dok-besl-alt" />
        <input value={anbefalt} onChange={(e) => updateAttributes({ anbefalt: e.target.value })}
          placeholder="Anbefaling (valgfritt)" className="dok-besl-alt" data-testid="dok-besl-anbefalt" />
        <input value={notat} onChange={(e) => updateAttributes({ notat: e.target.value })}
          placeholder={status === "decided" ? "Hva ble besluttet?" : "Notat / begrunnelse (valgfritt)"} className="dok-besl-notat" data-testid="dok-besl-notat" />
        <div className="flex items-center gap-2 mt-1.5">
          <input value={eier} onChange={(e) => updateAttributes({ eier: e.target.value })}
            placeholder="Eier" className="dok-blokk-input" data-testid="dok-besl-eier" />
          <input type="date" value={frist} onChange={(e) => updateAttributes({ frist: e.target.value })}
            className="dok-blokk-input" data-testid="dok-besl-frist" />
        </div>
      </div>
    </NodeViewWrapper>
  );
}
